import React from 'react'
import { motion } from 'framer-motion'
import AIChatProjectOverview from '../organisms/ProjectsList/AIChatProject/AIChatProjectOverview'
import AIChatProjectContent from '../organisms/ProjectsList/AIChatProject/AIChatProjectContent'
import AppsTestimonials from '../molecules/AppsTestimonials/AppsTestimonials'
import CompanyLogoImage from '../molecules/CompanyLogoImage/CompanyLogoImage'
import ContactHelp from '../molecules/ContactHelp/ContactHelp'
import Footer from '../organisms/Footer/Footer'
import { getPageData, useData } from '../../app/helper/functions'

const AIChatPage = () => {
    const { data } = useData();
    const aiChatProject = getPageData(data, 'aiChatProjectPage');
    const { title, description } = aiChatProject?.aichatProjectDetails ?? {};

    // Animation variants
    const fadeInUp = {
        hidden: { opacity: 0, y: 60 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.8, ease: "easeOut" }
        }
    };

    const staggerContainer = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3
            }
        }
    };

    return (
        <div className='bg-aiChatColor overflow-x-hidden'>
            <div className=''>
                <motion.div
                    className='flex justify-center items-center gap-2 sm:gap-4 px-4 sm:pr-16 pt-20 md:pt-32 lg:pt-52 pb-6 sm:pb-10'
                    initial="hidden"
                    animate="visible"
                    variants={staggerContainer}
                >
                    <motion.div
                        className='text-white flex flex-col gap-2 relative sm:pl-[9%] text-center w-full'
                        variants={staggerContainer}
                    >
                        <motion.div
                            className='capitalize font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl'
                            variants={fadeInUp}
                        >
                            {title}
                        </motion.div>
                        <motion.div
                            className='font-medium text-lg sm:text-xl md:text-2xl px-2 sm:px-[10%]'
                            variants={fadeInUp}
                        >
                            {description}
                        </motion.div>
                    </motion.div>
                </motion.div>
            </div>

            <AIChatProjectContent aiChatProject={aiChatProject} />

            <motion.div
                // initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true, amount: 0.3 }}
            >
                <AIChatProjectOverview aiChatProject={aiChatProject} />
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true, amount: 0.3 }}
            >
                <AppsTestimonials sliderColor='#242A69' bgUnActiveColor={'bg-[#13174c]'} color='#2135ff' bgcolor={'bg-[#2135ff]'} />
            </motion.div>

            <motion.div
                className='p-4 sm:p-6 md:p-10 px-4 sm:px-16 md:px-36'
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true, amount: 0.3 }}
            >
                <CompanyLogoImage borderColor='border-[#242A69]' bgColor='bg-[#0B1046]' />
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true, amount: 0.3 }}
                className="px-4 sm:px-0"
            >
                <ContactHelp title="Let's connect & achieve your business goals together" buttonTitle='CONTACT US' />
            </motion.div>

            <Footer />
        </div>
    )
}

export default AIChatPage
